import dayjs from "dayjs";
import { Cookies } from "react-cookie";
import i18n from "i18next";

export const deepClone = (obj: any) => {
    return JSON.parse(JSON.stringify(obj));
}

export const sleep = (ms:number) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const getCookie = (name: string) => {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop()?.split(";").shift();
}

//ex setCookie('username', 'john_doe', new Date('2023-10-17T00:00:00'));
export const setCookie = (name:string, value:string, expires?:Date) => {
    const cookies = new Cookies();
    let expiresDate = null;
    if (expires) {
        expiresDate = expires;
    } else {
        expiresDate = dayjs().add(1, 'day').toDate();
    }
    cookies.set(name, value, {domain: window.location.hostname, path: '/', expires: expiresDate});
};


export enum resolutionOptions {
    SD = 'SD',
    HD = 'HD',
    FHD = 'FHD',
    _2K = '2K',
    _4K = '4K'
}
export const getStandardResolutionByName = (name: string) => {
    switch (name) {
        case resolutionOptions.SD:
            return { width: 854, height: 480 };
        case resolutionOptions.HD:
            return { width: 1280, height: 720 };
        case resolutionOptions.FHD:
            return { width: 1920, height: 1080 };
        case resolutionOptions._2K:
            return { width: 2560, height: 1440 };
        case resolutionOptions._4K:
            return { width: 3840, height: 2160 };
        default:
            return { width: 1280, height: 720 };
    }
}

export const formatNumbers = (num:number) => {
  return num.toLocaleString(i18n.language.includes("en") ? "en-EN" : "it-IT");
}

export function convertToCents(value: number | string): number {
    // Converti il valore in una stringa, nel caso in cui non lo sia.
    let valueAsString = value.toString();

    // Determina il formato del numero basandosi sulla posizione dell'ultimo separatore (punto o virgola).
    const lastDotIndex = valueAsString.lastIndexOf('.');
    const lastCommaIndex = valueAsString.lastIndexOf(',');

    // Se l'ultimo separatore è una virgola, sostituisci tutte le virgole con il punto e rimuovi i punti come separatori delle migliaia.
    // Altrimenti, se l'ultimo separatore è un punto, rimuovi tutte le virgole (assumendo che siano separatori delle migliaia).
    if (lastCommaIndex > lastDotIndex) {
        // Il formato usa la virgola come separatore decimale.
        valueAsString = valueAsString.replace(/\./g, '').replaceAll(',', '.');
    } else {
        // Il formato usa il punto come separatore decimale.
        valueAsString = valueAsString.replace(/,/g, '');
    }

    // Converti il valore in un numero float e moltiplicalo per 100 per ottenere i centesimi.
    const cents = parseFloat(valueAsString) * 100;

    // Arrotonda il risultato per evitare problemi di precisione dei numeri floating point e convertilo in un intero.
    return Math.round(cents);
}

/*
export interface IAutocompleteKeyDownOption {
    options: ReadonlyArray<any>;
    value: any;
    isMultiple: boolean | undefined;
    onChange: (value: any) => void;
}
export const handleAutocompleteKeyDown =  (props:IAutocompleteKeyDownOption) => async(event:any) => {
    if (event.key === 'Tab' || event.key === 'Enter') {
        if ((!props.value || props.value === '' || (props.value instanceof Array && props.value.length === 0))
            && props.options && props.options.length > 0) {
            // Seleziona il primo valore disponibile
            if (props.isMultiple) {
                props.onChange([props.options[0]])
            } else {
                props.onChange(props.options[0])
            }
            event.preventDefault();  // Impedisci il comportamento di defaultevent.preventDefault();  // Impedisci il comportamento di default
        }
    }
};*/
